import styles from './UIGameCount.module.scss'
import {PlayerColor} from '@colonist/game-states'
// eslint-disable-next-line no-restricted-imports
import clsx from 'clsx'
import ButtonBadgeBackgroundRed from '@static/images/button_badge_background_red.svg'
import ButtonBadgeBackgroundBlue from '@static/images/button_badge_background_blue.svg'
import ButtonBadgeBackgroundOrange from '@static/images/button_badge_background_orange.svg'
import ButtonBadgeBackgroundGreen from '@static/images/button_badge_background_green.svg'
import ButtonBadgeBackgroundBlack from '@static/images/button_badge_background_black.svg'
import ButtonBadgeBackgroundBronze from '@static/images/button_badge_background_bronze.svg'
import ButtonBadgeBackgroundSilver from '@static/images/button_badge_background_silver.svg'
import ButtonBadgeBackgroundGold from '@static/images/button_badge_background_gold.svg'
import ButtonBadgeBackgroundWhite from '@static/images/button_badge_background_white.svg'
import ButtonBadgeBackgroundPurple from '@static/images/button_badge_background_purple.svg'
import ButtonBadgeBackgroundMysticBlue from '@static/images/button_badge_background_mysticblue.svg'
import ButtonBadgeBackgroundPink from '@static/images/button_badge_background_pink.svg'
import {ImageURL} from '@colonist/types'

const buttonBadgeBackgroundsByColor: Record<PlayerColor, ImageURL> = {
    [PlayerColor.None]: '' as ImageURL,
    [PlayerColor.Red]: ButtonBadgeBackgroundRed,
    [PlayerColor.Blue]: ButtonBadgeBackgroundBlue,
    [PlayerColor.Orange]: ButtonBadgeBackgroundOrange,
    [PlayerColor.Green]: ButtonBadgeBackgroundGreen,
    [PlayerColor.Black]: ButtonBadgeBackgroundBlack,
    [PlayerColor.Bronze]: ButtonBadgeBackgroundBronze,
    [PlayerColor.Silver]: ButtonBadgeBackgroundSilver,
    [PlayerColor.Gold]: ButtonBadgeBackgroundGold,
    [PlayerColor.White]: ButtonBadgeBackgroundWhite,
    [PlayerColor.Purple]: ButtonBadgeBackgroundPurple,
    [PlayerColor.MysticBlue]: ButtonBadgeBackgroundMysticBlue,
    [PlayerColor.Pink]: ButtonBadgeBackgroundPink,
} as const

export interface UIGameCountProps {
    className?: string
    count: number
    color: PlayerColor
}

export function UIGameCount({
    className,
    count,
    color,
}: UIGameCountProps) {
    const backgroundImageSrc = buttonBadgeBackgroundsByColor[color]

    return <div className={clsx(styles.container, className)}>
        <img className={styles.backgroundImage} src={backgroundImageSrc} />
        <div className={styles.count}>{count}</div>
    </div>
}
